import { Stack, Typography } from "@mui/material";

export const cyIds = {
  header: "wiz-header",
  logo: "wiz-logo",
};

const WizAssetsTabHeader = ({ connectButton }: { connectButton: React.JSX.Element }) => (
  <Stack direction="row" justifyContent="space-between" sx={{ pt: 2, pb: 2.5 }}>
    <Typography variant="h1" data-cy="wiz-header">
      Wiz
    </Typography>
    {connectButton}
  </Stack>
);

export default WizAssetsTabHeader;
